'use client';
import { format } from 'date-fns';
import { useClientHasRendered } from '@domain/session/useClientHasRendered';
import { Text } from '../Text/Text';
import { TextLoader } from '../Text/TextLoader';
import { variants } from '../Text/variants';
import { ComponentType, FunctionComponent } from 'react';

export const HydrationSafeDate = ({
  as = 'p',
  className,
  date,
  isLoading = false,
  formatStr = 'MMMM do, yyyy',
  loaderForegroundColor,
  loaderBackgroundColor,
  uniqueLoaderKey = 'hydration-safe-date-loader',
  textVariant = 'sm',
}: {
  as?: string | ComponentType<any> | FunctionComponent<any>;
  className?: string;
  date?: string;
  formatStr?: string;
  loaderForegroundColor?: string;
  loaderBackgroundColor?: string;
  isLoading?: boolean;
  uniqueLoaderKey?: string;
  textVariant?: keyof typeof variants;
}) => {
  const clientHasRendered = useClientHasRendered();
  const safeDate = clientHasRendered
    ? format(date ? new Date(date) : new Date(), formatStr)
    : undefined;

  if (!safeDate || isLoading) {
    return (
      <TextLoader
        backgroundColor={loaderBackgroundColor}
        foregroundColor={loaderForegroundColor}
        uniqueKey={uniqueLoaderKey}
        variant={textVariant}
        width={120}
      />
    );
  }

  return (
    <Text as={as} variant={textVariant} className={className}>
      {safeDate}
    </Text>
  );
};
